import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes'
import './global.css'

ReactDOM.render(<Routes />, document.getElementById('root'));                      